module.exports = __webpack_public_path__ + "img/ruler-pencil-primary.f20064cc.svg";